import React, { useState, useEffect } from 'react';
import './index.scss';
import { EaseDrawer } from '../../libs/EaseDrawer';
import { isMobile } from "react-device-detect";
import { Merchant } from '../../models';
import { Text5, Text1 } from "../../styles";
import moment from 'moment';
import { handleApiExceptions, printRupee } from "../../app_methods";
import { EaseTable } from '../../libs/EaseTable';
import { PaginationKaBaap } from '../Common';
import { Icon } from 'antd';


const WalletAccountStatementDrawer = (props) => {
    const [records, setRecords] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = useState({
    });

    useEffect(() => {
            if (props.visible) {
                fetchAccountStatement(pagination);
            }
        }, [props.visible]);

    const prepFilters = (filters) => {
            let _filters = { ...filters };
            if (_filters.created_at && _filters.created_at.length) {
                _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
                _filters.created_at_end = moment().isBefore(_filters.created_at[1])?moment().format("YYYY-MM-DD"):_filters.created_at[1].format("YYYY-MM-DD");
                delete _filters.created_at;
            }
            return _filters;
        };

    const tableColumns = [
                {
                    title: "Date",
                    key: "created_at",
                    render: (record) => <Text5>{moment(record.created_at).format("lll")}</Text5>
                }, {
                    title: "Unique Reference ID",
                    key: "unique_reference_id",
                    render: (record) =>
                        <div>
                            <Text5>{record.unique_reference_id || "---"}</Text5>
                        </div>
                }, {
                    title: "Narration",
                    width: "25%",
                    key: "narration",
                    render: (record) =>
                        <div>
                            <Text5>{record.narration || "---"}</Text5>
                        </div>
                }, {
                    title: <>Debit <Icon style={{ color: "red" }} type="arrow-up" /></>,
                    key: "debit_amount",
                    render: (record) => <Text5>{record.entry_type == "debit" ? printRupee(record.amount, 3) : "---"}</Text5>
                }, {
                    title: <>Credit <Icon style={{ color: "green" }} type="arrow-down" /></>,
                    key: "credit_amount",
                    render: (record) => <Text5>{record.entry_type == "credit" ? printRupee(record.amount, 3) : "---"}</Text5>
                }, {
                    title: "Closing Balance",
                    key: "closing_balance",
                    render: (record) => <Text5>{printRupee(record.closing_balance, 3)}</Text5>
                }
            ];
    
    let filterNodes = [
                {
                    label: "Debit/Credit",
                    field: "entry_type",
                    placeholder: "Select Transaction Type",
                    inputType: "select",
                    defaultValue: null,
                    options: [{
                        key: "1",
                        value: "debit",
                        label: "Debit"
                    }, {
                        key: "2",
                        value: "credit",
                        label: "Credit"
                    }]
                },                 {
                label: "Date",
                field: "created_at",
                placeholder: "Enter Date",
                inputType: "date_range",
                preventClear: true,
                defaultValue: [moment().subtract(3, 'days'), moment()]
            }
            ]

    const fetchAccountStatement = async (_pagination, _filters = filters) => {
            setIsTableLoading(true);
            const response = await Merchant.wallet_account_statetment({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) });
            if (!response.success) {
                setIsTableLoading(false);
                handleApiExceptions(response);
                return;
            }
            setRecords(response.data.results);
            setPagination({ ..._pagination, ...response.data.pagination });
            setIsTableLoading(false);
        };

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        let _filters = tableInfo.filters;
        setPagination(_pagination);
        setFilters(_filters);
        fetchAccountStatement(_pagination, _filters);
    };

    const onPageChange = (_pagination) => {
            setPagination({ ..._pagination });
            fetchAccountStatement({ ..._pagination }, filters);
        };

    return (
        <EaseDrawer
            className=""
            width={1000}
            title={false}
            visible={props.visible}
            onClose={props.toggleWalletAccountStatementDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                 <div>
                    <Text1 className="d-block" strong>Account Statement</Text1>
                </div>
                <EaseTable
                    rowKey="id"
                    loading={isTableLoading}
                    data={records}
                    columns={tableColumns}
                    pagination={pagination}
                    filterNodes={filterNodes}
                    handleTableChange={handleTableChange}
                    totalRecords={pagination.total}
                    fixedSelectable={!isMobile}
                />
                <PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
            </div>
        </EaseDrawer>
    )
};

export default WalletAccountStatementDrawer;